import { fetcher } from "helpers/fetcher";

import {
  TUpdateEmployeePasswordReq,
  TUpdateEmployeePasswordRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeePassword = async (
  payload: TUpdateEmployeePasswordReq
) => {
  return await fetcher<
    TUpdateEmployeePasswordRes,
    TUpdateEmployeePasswordReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_PASSWORD, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_EMPLOYEE_PASSWORD.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateEmployeePassword = async (
  payload: TUpdateEmployeePasswordReq
) => {
  return (await updateEmployeePassword(payload)).data;
};

mutationUpdateEmployeePassword._key = (payload: TUpdateEmployeePasswordReq) => [
  ENDPOINT.USER.UPDATE_EMPLOYEE_PASSWORD.url,
  payload,
];
